import { useTranslation } from "react-i18next";
import { Import, ImportStatus } from "types/Import";

type Props = {
  item: Import;
};

function ImportZimsContentCard({ item }: Props) {
  const { t } = useTranslation();

  return (
    item.parsedContent &&
    item.parsedContent.totalEntries &&
    item.parsedContent.totalEntries > 0 &&
    item.status !== ImportStatus.ERROR && (
      <div className="flex flex-col">
        <span>{`${t("import.nbTotalAnimals")} ${
          item.parsedContent.totalEntries
        }`}</span>
        {item.status === ImportStatus.COMPLETE_WITH_ERRORS && (
          <span>{`${t("import.nbErrors")} ${
            item.parsedContent.totalErrors
          }`}</span>
        )}
      </div>
    )
  );
}

export default ImportZimsContentCard;
